import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';
import { filter, first, map, tap } from 'rxjs/operators';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  networkStatus: Observable<boolean>;
  isOnline: boolean;

  private openedNotification: MatSnackBarRef<any>;

  constructor(@Inject(WINDOW) private window: Window, private _snackBar: MatSnackBar) {
    this.networkStatus = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    ).pipe(
      tap(() => (this.isOnline = window.navigator.onLine)),
      map(() => window.navigator.onLine)
    );

    this.networkStatus.pipe(
      filter((isOnline) => isOnline),
      tap(() => {
        if (this.openedNotification) {
          this.openedNotification.dismiss();
        }
      })
    );
  }

  notifyUser(canceler: BehaviorSubject<boolean>) {
    this.openedNotification = this._snackBar.open('Your request has been postponed', 'Cancel', {
      duration: 5000,
    });

    this.openedNotification
      .onAction()
      .pipe(
        tap(() => canceler.next(true)),
        first()
      )
      .subscribe();
  }
}
